import { createRoot } from "react-dom/client";
import FrontEnd from "../public/Components/FrontEnd";
import { findParentAnchorTag } from "../utils";


export const renderModel = ({ div, dom, position, styles, attributes, isPagination, type }) => {
    if (position === "bottom") {
        setTimeout(() => {
            dom.appendChild(div);
            dom = div;
            dom.setAttribute("style", `width:${dom.offsetWidth > 0 ? dom.offsetWidth + "px" : "100%"};height:calc(${styles.height} + ${isPagination ? "100px" : "0px"})`);
            const root = createRoot(dom);
            root.render(<FrontEnd attributes={attributes} />, dom);
        }, 100);
    } else if (position === "top") {
        dom.insertBefore(div, dom.firstChild);
        dom = div;
        setTimeout(() => {
            dom.setAttribute("style", `width:${dom.offsetWidth > 0 ? dom.offsetWidth + "px" : "100%"};height:calc(${styles.height} + ${isPagination ? "100px" : "0px"})`);
            const root = createRoot(dom);
            root.render(<FrontEnd attributes={attributes} />, dom);
        }, 100);
    } else {
        dom.setAttribute("style", `width:${dom.offsetWidth > 0 ? dom.offsetWidth + "px" : "100%"};height:calc(${styles.height} + ${isPagination && type !== "popup" ? "100px" : "0px"})`);
        const root = createRoot(dom);
        root.render(<FrontEnd attributes={attributes} />, dom);
    }

    // set height of the model like other product
    if (dom.classList.contains("productListItem")) {
        const targetSibling = dom.classList.contains('block-theme') ? 'previousElementSibling' : 'nextElementSibling';

        const height = dom[targetSibling]?.offsetHeight;

        if (height) {
            dom.style.height = height + "px";
            dom[targetSibling].style.display = "none";
            const interval = setTimeout(() => {
                if (dom.querySelector(".modelViewerBlock")) {
                    clearInterval(interval);
                    dom.querySelector(".modelViewerBlock").style.height = height + "px";
                    dom.querySelector(".bp_model_parent").setAttribute("style", `height:${height + "px"};min-width: 100%`);
                    const anchorTag = findParentAnchorTag(dom);

                    anchorTag.addEventListener("click", function (e) {
                        if (e.target.id === "openBtn" || e.target.id === "closeBtn" || e.target.tagName === "MODEL-VIEWER") {
                            e.preventDefault();
                        }
                    });
                }
            }, 500);
        }
    }
};

export default renderModel;